import { render, staticRenderFns } from "./DeleteSmsTemplateDialog.vue?vue&type=template&id=1a09a908&"
import script from "./DeleteSmsTemplateDialog.vue?vue&type=script&lang=ts&"
export * from "./DeleteSmsTemplateDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports